import { render, staticRenderFns } from "./transferRoles.vue?vue&type=template&id=2797e932&scoped=true"
import script from "./transferRoles.vue?vue&type=script&lang=js"
export * from "./transferRoles.vue?vue&type=script&lang=js"
import style0 from "./transferRoles.vue?vue&type=style&index=0&id=2797e932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2797e932",
  null
  
)

export default component.exports